import { useState } from "react";
import { Link } from "react-router-dom";

export default function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="p-4 flex flex-col border-b border-gray-700">
      <div className="flex justify-between items-center">
        {/* Logo/Name on left */}
        <h1 className="text-xl font-bold md:w-1/4 whitespace-nowrap">Eyad Kurd-Misto</h1>
        
        {/* Centered navigation links */}
        <div className="hidden md:flex space-x-6 justify-center w-2/4">
          <Link to="/" className="hover:text-blue-400 transition-colors">
            Home
          </Link>
          <Link to="/projects" className="hover:text-blue-400 transition-colors">
            Projects & Research
          </Link>
          <Link to="/about" className="hover:text-blue-400 transition-colors">
            About Me
          </Link>
          <Link to="/resume" className="hover:text-blue-400 transition-colors">
            Resume
          </Link>
        </div>
        
        {/* LinkedIn link on right */}
        <div className="hidden md:flex justify-end w-1/4">
          <a
            href="https://www.linkedin.com/in/eyad-kurd-misto/"
            className="text-blue-400 hover:text-blue-300 transition-colors flex items-center"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn Profile"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 mr-1" 
              fill="currentColor" 
              viewBox="0 0 24 24"
            >
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
            LinkedIn
          </a>
        </div>
        
        {/* Mobile menu button */}
        <div className="md:hidden">
          <button 
            className="text-white focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 flex flex-col space-y-3 pb-3">
          <Link 
            to="/" 
            className="hover:bg-gray-800 py-2 px-3 rounded transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/projects" 
            className="hover:bg-gray-800 py-2 px-3 rounded transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            Projects & Research
          </Link>
          <Link 
            to="/about" 
            className="hover:bg-gray-800 py-2 px-3 rounded transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            About Me
          </Link>
          <Link 
            to="/resume" 
            className="hover:bg-gray-800 py-2 px-3 rounded transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            Resume
          </Link>
          
          {/* LinkedIn link in mobile menu */}
          <a
            href="https://www.linkedin.com/in/eyad-kurd-misto/"
            className="hover:bg-gray-800 py-2 px-3 rounded transition-colors flex items-center"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setIsMenuOpen(false)}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 mr-2" 
              fill="currentColor" 
              viewBox="0 0 24 24"
            >
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
            LinkedIn
          </a>
        </div>
      )}
    </nav>
  );
} 